import { ActionReducerMapBuilder, PayloadAction, createSlice } from '@reduxjs/toolkit'
import { withLoadingReducer } from 'utils/reducerHandler'
import type { ThresholdType } from 'features/Order/services/additionalSLABacklog'
import { SLICE_NAME, fetchLocations, fetchThresholds } from './thunk'

type LocationType = {
  location_id: number
  location_name: string
  location_type: string
}

export type ASLABacklogStateType = {
  isLoading: boolean
  locations: LocationType[]
  selectedLocation: LocationType | null
  factorType: 'PICKER_BACKLOG' | 'DRIVER_BACKLOG'
  thresholds: ThresholdType[]
  showPopupAdd: boolean
  editingRowId: number | null
}

export const initialState: ASLABacklogStateType = {
  isLoading: false,
  locations: [],
  selectedLocation: null,
  factorType: 'PICKER_BACKLOG',
  thresholds: [],
  showPopupAdd: false,
  editingRowId: null,
}

const aslaBacklogSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setSelectedLocation: (state, action: PayloadAction<LocationType | null>) => {
      state.selectedLocation = action.payload
    },
    setFactorType: (state, action: PayloadAction<'PICKER_BACKLOG' | 'DRIVER_BACKLOG'>) => {
      state.factorType = action.payload
    },
    setShowPopupAdd: (state, action: PayloadAction<boolean>) => {
      state.showPopupAdd = action.payload
    },
    setEditingRowId: (state, action: PayloadAction<number | null>) => {
      state.editingRowId = action.payload
    },
  },
  extraReducers: withLoadingReducer(
    (builder: ActionReducerMapBuilder<ASLABacklogStateType>) => {
      builder.addCase(fetchLocations.fulfilled, (state, action) => {
        state.locations = action.payload.data.filter(
          (loc: LocationType) => loc.location_type.toUpperCase() === 'HUB',
        )
      })
      builder.addCase(fetchThresholds.fulfilled, (state, action) => {
        state.thresholds = action.payload.thresholds
        state.editingRowId = null
      })
    },
    [fetchLocations, fetchThresholds],
  ),
})

export const { setSelectedLocation, setFactorType, setShowPopupAdd, setEditingRowId } =
  aslaBacklogSlice.actions
export default aslaBacklogSlice.reducer
